const FEATURES = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '支持全集漫画下拉式阅读，无需翻页，一滑到底。流畅丝滑的阅读体验，让追漫更沉浸。',
  },
  {
    icon: 'ri-global-line',
    title: '海量资源库',
    desc: '汇聚10万+韩漫、日漫、国漫资源，涵盖恋爱、奇幻、悬疑、热血等全品类漫画内容。',
  },
  {
    icon: 'ri-time-line',
    title: '每日同步更新',
    desc: '热门连载漫画每日更新，第一时间追更最新章节。支持收藏订阅，更新自动提醒。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝阅读',
    desc: '支持PC、手机、平板等多设备无缝切换。阅读进度云端同步，随时随地继续阅读。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净阅读',
    desc: '无弹窗干扰，无恶意广告。纯净阅读环境，保护读者隐私，让免费漫画阅读更安心。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            平台特色
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么千万读者选择虫虫漫画网看<strong>免费漫画</strong>
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-background-100 hover:bg-background-200/80 rounded-xl p-5 md:p-6 border border-background-200/60 transition-all duration-300 cursor-default"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}